<template>
    <article class="cmp cmp-product-thumb cmp-product-thumb--grid" :data-testing="item.variation.id">
        <div class="article-inner">
            <div class="article-inner-image">

                <template v-if="(item.variation.availability.id==5 && ((stoffparent == null || stoffparent!='parent') || (item.variation.minimumOrderQuantity > item.stock.net) && stoffparent!='parent') && item.item.stockLimitation != 1)">
                    <div class="special-tags">
                        <span class="badge badge-offer badge-danger">
                            {{ $translate("Snaply5::Template.catAusverkauft") }}
                        </span>
                    </div>
                </template>
                <template v-else>
                    <template v-if="item.item.storeSpecial != null">
                        <template v-if="showrrp || item.item.storeSpecial.id==1">
                            <template v-if="item.prices.rrp.price.value > item.prices.default.price.value">
                                <template v-if="item.prices.rrp.price.value > item.prices.default.price.value">
                                    <div class="special-tags">
                                        <span class="badge badge-offer badge-info">
                                           {{ percentFixed }} %
                                        </span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="special-tags">
                                        <span class="badge badge-offer badge-info">
                                            {{ $translate("Snaply5::Template.catAngebot") }}
                                        </span>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <template v-if="item.item.storeSpecial.id==2">
                            <div class="special-tags">
                                <span class="badge badge-offer badge-info">
                                    {{ $translate("Snaply5::Template.catNew") }}
                                </span>
                            </div>
                        </template>
                        <template v-if="item.item.storeSpecial.id==3">
                            <div class="special-tags">
                                <span class="badge badge-offer badge-info">
                                    {{ $translate("Snaply5::Template.catTop") }}
                                </span>
                            </div>
                        </template>
                    </template>
                </template>
                <a :href="item | clickable" :alt="item | itemName" :title="item | itemName">
                    <template v-if="showVariationImagePossible">
                      <template v-if="item.images.all.length > 1 && showSecondImage">
                        <template v-if="endless">
                          <img class="img-fluid owl-lazy" :data-src="item.images.all[1].urlSecondPreview">
                        </template>
                        <template v-else>
                          <lazy-img   :image-url="item.images.all[1].urlSecondPreview"
                                      class="img-fluid"
                                      :alt="item | itemName"
                                      :title="item | itemName">
                          </lazy-img>
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="endless">
                          <template v-if="item.images.variation.length > 0">
                            <img class="img-fluid owl-lazy" :data-src="item.images.variation[0].urlSecondPreview">
                          </template>
                          <template v-else>
                            <img class="img-fluid owl-lazy" :data-src="item.images.all[0].urlSecondPreview">
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="item.images.variation.length > 0">
                            <lazy-img   :image-url="item.images.variation[0].urlSecondPreview"
                                        class="img-fluid"
                                        :alt="item | itemName"
                                        :title="item | itemName">
                            </lazy-img>
                          </template>
                          <template v-else>
                            <lazy-img   :image-url="item.images.all[0].urlSecondPreview"
                                        class="img-fluid"
                                        :alt="item | itemName"
                                        :title="item | itemName">
                            </lazy-img>
                          </template>
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="endless">
                        <template v-if="item.images.variation.length > 0">
                          <img class="img-fluid owl-lazy" :data-src="item.images.variation[0].urlSecondPreview">
                        </template>
                        <template v-else>
                          <img class="img-fluid owl-lazy" :data-src="item.images.all[0].urlSecondPreview">
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="item.images.variation.length > 0">
                          <lazy-img   :image-url="item.images.variation[0].urlSecondPreview"
                                      class="img-fluid"
                                      :alt="item | itemName"
                                      :title="item | itemName">
                          </lazy-img>
                        </template>
                        <template v-else>
                          <lazy-img   :image-url="item.images.all[0].urlSecondPreview"
                                      class="img-fluid"
                                      :alt="item | itemName"
                                      :title="item | itemName">
                          </lazy-img>
                        </template>
                      </template>
                    </template>
                    <template v-if="showproducer!=null">
                        <span class="producer">
                            {{ $translate("Snaply5::Template.singleAuthor") }} {{ showproducer }}
                        </span>
                    </template>
                    <template v-else>
                        <template v-if="countvars > 0">
                            <span class="producer">
                                {{ countvars }}  {{ $translate("Snaply5::Template.catVariations") }}
                            </span>
                        </template>
                        <template v-else-if="countvars<=1 && stoffparent=='parent'">
                            <span class="producer">
                                {{ $translate("Snaply5::Template.catManyColors") }}
                            </span>
                        </template>
                    </template>
                </a>
              <template v-if="item.prices.default.price.value != 0 && !item.item.free1" >
                <csaddtolist :variation-id="item.variation.id" :single-item="false"></csaddtolist>
              </template>
            </div>
            <slot name="item-details">
                <div class="article-inner-always">
                <template v-if="item.prices.default.price.value != 0 || ParentPrice != 0">
                    <div class="d-flex split">
                        <div class="category-feedback d-flex" v-if="calcWidth() > 0">
                          <div class="feedback-stars-average feedback-category-view">
                            <div class="feedback-stars-background clearfix">
                              <div class="feedback-star"><i class="fa fa-star"></i></div>
                              <div class="feedback-star"><i class="fa fa-star"></i></div>
                              <div class="feedback-star"><i class="fa fa-star"></i></div>
                              <div class="feedback-star"><i class="fa fa-star"></i></div>
                              <div class="feedback-star"><i class="fa fa-star"></i></div>
                            </div>
                            <div class="feedback-stars-overlay-wrap" :style="'width:'+calcWidth()+'%'">
                              <div class="feedback-stars-overlay clearfix">
                                <div class="feedback-star"><i class="fa fa-star"></i></div>
                                <div class="feedback-star"><i class="fa fa-star"></i></div>
                                <div class="feedback-star"><i class="fa fa-star"></i></div>
                                <div class="feedback-star"><i class="fa fa-star"></i></div>
                                <div class="feedback-star"><i class="fa fa-star"></i></div>
                              </div>
                            </div>
                          </div>
                          ({{ item.item.feedbackCount }})
                        </div>
                        <template v-if="ParentPrice!=0">
                            <div class="prices">
                                <div class="price">
                                    <span class="price-n">
                                      <template v-if="ParentPrice > 0">
                                          {{ ParentPrice | currency }}
                                      </template>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <template v-if="item.variation.intervalOrderQuantity">
                                <div class="price">
                                    <span class="price-n" :class="{'red':showrrp }">
                                        <template v-if="item.prices.default.price.value * item.variation.minimumOrderQuantity > 0">
                                          <template v-if="item.variation.minimumOrderQuantity == 0.1">
                                            {{ item.prices.default.price.value * (item.variation.minimumOrderQuantity * 5) | currency }}
                                          </template>
                                          <template v-else>
                                            {{ item.prices.default.price.value * item.variation.minimumOrderQuantity | currency }}
                                          </template>

                                        </template>
                                    </span>
                                    <template v-if="showrrp">
                                         <span class="rrp">
                                           <template v-if="item.prices.rrp.price.value * item.variation.minimumOrderQuantity > 0">
                                             <template v-if="item.variation.minimumOrderQuantity == 0.1">
                                                {{ item.prices.rrp.price.value * (item.variation.minimumOrderQuantity * 5) | currency }}
                                             </template>
                                             <template v-else>
                                               {{ item.prices.rrp.price.value * item.variation.minimumOrderQuantity | currency }}
                                             </template>
                                           </template>
                                         </span>
                                    </template>
                                </div>
                            </template>
                            <template v-else>
                                <span class="price-n" :class="{'red':showrrp }">
                                   <template v-if="item.prices.default.price.value > 0">
                                      {{ item.prices.default.price.formatted }}
                                   </template>
                                </span>
                                <template v-if="showrrp">
                                    <span class="rrp">
                                        <template v-if="item.prices.rrp.price.value > 0">
                                          {{ item.prices.rrp.price.formatted }}
                                        </template>
                                    </span>
                                </template>
                            </template>
                        </template>
                    </div>
                </template>
                <template v-if="item.unit && item.unit.unitOfMeasurement == 'MTR'">
                    <span class="small-info-price">
                        <template v-if="item.variation.minimumOrderQuantity == 0.1">
                            <span>
                                {{ item.variation.minimumOrderQuantity * 5 }} {{ item.unit.names.name }} | {{ item.prices.default.basePrice }}
                            </span>
                        </template>
                        <template v-else>
                            <span>{{ item.unit.content }}</span>
                            {{ item.unit.names.name }}
                            <template v-if="item.unit.content !=1">
                             | {{ item.prices.default.basePrice }}
                            </template>
                        </template>
                    </span>
                </template>
                <template v-else-if="item.unit && ParentPrice!=0">
                    <span class="small-info-price">
                        <template v-if="ParentPricehalbm2 == 0 ">
                            <span>
                                 0,5 {{ $translate("Snaply5::Template.catMeterWare") }} | {{ (2 * ParentPrice)  | currency }} / {{ $translate("Snaply5::Template.catMeterWare") }}
                            </span>
                        </template>
                        <template v-else>
                            <span>
                                {{ ParentPricehalbm2 }} m&sup2; | {{ (ParentPrice /ParentPricehalbm2 ) }} {{ $translate("Snaply5::Template.catCurrencyMeter2") }}
                            </span>
                        </template>
                     </span>
                </template>
                <template v-else-if="item.prices.default.basePrice && item.prices.default.basePrice != 'N / A'">
                    <span class="small-info-price">
                        <span>
                            <template v-if="item.prices.default.basePrice">
                                <template v-if="item.unit.names.unitId == 49">
                                    <!-- 100 meter sind doof -->
                                    {{ item.unit.content*100 }} {{ $translate("Snaply5::Template.catMeterWare") }} |  {{ item.prices.default.basePrice }}
                                </template>
                                <template v-else>
                                    {{ item.unit.content }} {{ item.unit.names.name }} <template v-if="item.prices.default.basePrice !='' && item.prices.default.basePrice !='N / A'"> | {{ item.prices.default.basePrice }} </template>
                                </template>
                            </template>
                        </span>
                    </span>
                </template>
                <a class="name" :href="item | clickable">
                    {{ item | itemName }}
                    <template v-if="item.attributes.length > 0 && showAttributes">
                      <br>
                      <span v-for="attr in item.attributes" :key="attr.id" class="cat-attr">
                        <span class="font-weight-bold">{{ attr.attribute.names.name }}:</span> {{ attr.value.names.name }}
                      </span>
                    </template>
                </a>
            </div>
                <template v-if="showCart">
                  <button class="btn btn-block btn-primary btn-danger" @click="addVariationToBasket(item.variation.id)">
                    {{ $translate("Snaply5::Template.singleColorToBasket") }}
                    <template v-if="dataLoading">
                      <i aria-hidden="true" class="fa fa-spin fa-circle-o-notch"></i>
                    </template>
                    <template v-else>
                      <i aria-hidden="true" class="fa fa-shopping-cart"></i>
                    </template>
                  </button>
                </template>
            </slot>
        </div>
    </article>
</template>

<script>
    import {mapActions, mapState} from "vuex";
import CategoryImageCarousel from "../components/itemList/CategoryImageCarousel.vue";
import ItemStoreSpecial from "../components/itemList/ItemStoreSpecial.vue";
import {isDefined} from "../helper/utils";
import NotificationService from "../services/NotificationService";

export default {
    components:
    {
        CategoryImageCarousel,
        ItemStoreSpecial
    },
    data: function()
    {
        return{
            stoffparent         :   null,
            ParentPrice         :   0,
            ParentPricem2       :   0,
            ParentPricehalbm2   :   0,
            dataLoading         :   false
        }
    },
    props: {
        endless:
        {
            type: Boolean,
            default:false
        },
        decimalCount:
        {
            type: Number,
            default: 0
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlSecondPreview"
        },
        showVariationImagePossible:
        {
          type:Boolean,
          default:false
        },
        showAttributes:
        {
          type:Boolean,
          default:false
        },
        wishIsActive:
        {
          type:Boolean,
          default:true
        },
        showCartLoading:
        {
          type:Boolean,
          default:false
        },
        showCart:
        {
          type:Boolean,
          default:false
        },
        showRating:
        {
          type: Boolean,
          default:false
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        forceUrlWithVariationId:
        {
            type: Boolean,
            default: false
        },


      itemdocument:
          {
            type: Object
          },
      incategory:
          {
            type: Number,
            default:0
          },
      loggedin:
          {
            type: Number,
            default:0
          },
      wishlist: {
        type:Object,
        default:() => {}
      }
      //   wishlist:
      //   {
      //       type:Boolean,
      //       default:false
      //   }
    },

    jsonDataFields: [
        "itemDataRef"
    ],
    created: function()
    {
        this.stoffparentCalc();
        this.grundpreiskram();
    },
    methods:
    {
        addVariationToBasket:function(variationId)
        {
            this.dataLoading = true;
            let _self = this;
            let data =
            {
              "variationId":variationId,
              "quantity": 1
            }
            $.ajax({
                type: 'POST',
                url: '/rest/io/basket/items/',
                data: data,
                success: function (responseData)
                {
                  NotificationService.success(
                      _self.$translate("Snaply5::Template.overlayTextSucces"),
                      _self.dataLoading = false
                  ).closeAfter(3000);
                },
                error: function (jqXHR, textStatus, errorThrown)
                {
                  NotificationService.error(
                      _self.$translate("Snaply5::Template.overlayTextFail"),
                      _self.dataLoading = false
                  );
                  // console.error(errorThrown);
                }
            });
        },
        calcWidth:function()
        {
          let itemInfo = '';
          if(this.itemData != undefined)
          {
            itemInfo = this.itemData
          }
          else
          {
            itemInfo = this.itemDataRef
          }
          if(itemInfo.item.feedback !== 0)
          {
            return (itemInfo.item.feedbackDecimal * 100) / 5;
          }
          else
          {
            return 0;
          }
        },
        stoffparentCalc: function ()
        {
            let itemInfo = '';
            if(this.itemData != undefined)
            {
                 itemInfo = this.itemData
            }
            else
            {
                 itemInfo = this.itemDataRef
            }
            if(itemInfo.hasOwnProperty('tags'))
            {
                for (let i = 0; i < itemInfo.tags.length; i++) {
                    if (itemInfo.tags[i].id == 16) {
                        this.stoffparent = 'parent';
                    }
                    if (itemInfo.tags[i].id == 17) {
                        this.stoffparent = 'child';
                    }
                }
            }
            else
            {
                this.stoffparent = null;
            }
        },
        grundpreiskram: function ()
        {
            let itemInfo = '';
            if(this.itemData != undefined)
            {
                itemInfo = this.itemData
            }
            else
            {

                itemInfo = this.itemDataRef
            }

            if(itemInfo.hasOwnProperty('variationProperties'))
            {

                let varProps = itemInfo.variationProperties;
                for(let i = 0; i < varProps.length; i++)
                {

                    if(varProps[i].id === 7)
                    {
                        for (let i2 = 0; i2 < varProps[i].properties.length; i2++) {
                            if (varProps[i].properties[i2].id == 10) {
                                this.ParentPrice = parseFloat(varProps[i].properties[i2].values.value);
                            }
                        }
                    }
                }
            }
            else
            {

                return 0;
            }


        },
        deleteFromWish: function(item)
        {
            let data =
            {
                "data":item,
                "id":item.variation.id
            }
            const fitem =
            {
                id: data.data.variation.id,
                wishListItem: data.data,
                index: this.wishListItems.findIndex(item => item.id === data.data.id)
            };

            this.removeWishListItem(fitem)
                .then(() => NotificationService.success(
                    this.$translate("Ceres::Template.wishListRemoved")
                ).closeAfter(3000));
        },
        ...mapActions([
            "removeWishListItem"
        ])
    },

    computed:
    {
        showSecondImage()
        {
          let tags = this.item.tags;
          let showSecondImage = false;
          for(let i = 0; i < tags.length; i++)
          {
            if (tags[i].id === 46)
            {
              showSecondImage = true;
            }
          }
          return showSecondImage;
        },
        showrrp()
        {
            if(this.item.prices.rrp != null)
            {
                if(this.item.prices.rrp.price.value > this.item.prices.default.price.value)
                {
                    return true
                }
            }
            else
            {
                return false
            }
        },
        wishlistactive()
        {
            return this.wishlist;
        },
        percentFixed()
        {
            return (((this.item.prices.default.price.value - this.item.prices.rrp.price.value) / this.item.prices.rrp.price.value)*100).toFixed(0)
        },
        countvars()
        {
            let itemInfo = '';
            if(this.itemData != undefined)
            {
                itemInfo = this.itemData.item
            }
            else
            {
                itemInfo = this.itemDataRef
            }
            if(itemInfo.free1)
            {
                let free = JSON.parse(itemInfo.free1)
                return free.length;
            }
            else
            {
                return 0;
            }

        },
        showproducer()
        {
            let itemInfo = '';
            if(this.itemData != undefined)
            {
                itemInfo = this.itemData.item
            }
            else
            {
                if(this.itemDataRef.hasOwnProperty('item'))
                {
                    itemInfo = this.itemDataRef.item
                }
                else
                {
                    itemInfo = this.itemDataRef
                }

            }
            let listNotToShow = ["Markenlos","AA Stoffe für Sortierung","Projekte Showroom","Snaply","Produktionsartikel","NICHT NOSTO","Sortierung Erscheinungsdatum","Lovely Casa","Kretzer","Lang Yarn",""]
            if(listNotToShow.indexOf(itemInfo.manufacturer.name) > 0)
            {
                return null
            }
            else
            {
                return itemInfo.manufacturer.name;
            }
        },

        item()
        {
            return this.itemData || this.itemDataRef;
        },

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
            return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
            return this.item.texts;
        },

        itemPrice()
        {
            return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemSetPrice()
        {
            return this.$options.filters.currency(
                this.item.prices.default.price.value,
                this.item.prices.default.currency
            );
        },

        urlWithVariationId()
        {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        ...mapState({
            showNetPrices: state => state.basket.showNetPrices,
            wishListItems: state => state.wishList.wishListItems

        })
    }
}
</script>
